import React, { useState } from 'react';
import NhsNumber from './nhsNumber';
import { Box } from '@mui/material';


function PatientDetails(props) {
    const [nhsNumber, setNHSNumber]= useState()
    
    //needs link to NHS api https://orange.testlab.nhs.uk/swagger-v0.html
    
    return (   
    <Box>
    <NhsNumber setNHSNumber={setNHSNumber}/>
    </Box> );
}

export default PatientDetails;